module.exports = (address1, address2) =>
	address1 && address2 && address1.toLowerCase() === address2.toLowerCase();
